import script from "./ClubPageAboutClub.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubPageAboutClub.vue?vue&type=script&setup=true&lang=js"

import "./ClubPageAboutClub.vue?vue&type=style&index=0&id=5d047d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d047d38"]])

export default __exports__